import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { fetchApplication, FETCH_APPLICATION} from "../../actions/student.action"

function* handleFetchApplication(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchApplication, action.payload);
    //extract the data here     
    yield put(fetchApplication.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(fetchApplication.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* fetchApplicationSaga() {
  yield takeLatest(FETCH_APPLICATION.REQUEST, handleFetchApplication);
}

export default fetchApplicationSaga;
